import methods from '@/enums/methods';

import TransactionMonitoringService from './base';

class AlertService extends TransactionMonitoringService {
    getUnverifiedAlerts() {
        return this.fetch({
            url: `${this.baseUrl}/clients/alerts`,
        });
    }

    getAlerts({
        ec,
        startDate,
        endDate,
        verified,
    }) {
        return this.fetch({
            url: `${this.baseUrl}/alerts`,
            params: {
                establishment_id: ec,
                start_date: startDate,
                end_date: endDate,
                verified,
            },
        });
    }

    getAlertType() {
        return this.fetch({
            url: `${this.baseUrl}/alert-types`,
        });
    }

    getMonitored() {
        return this.fetch({
            url: `${this.baseUrl}/clients/monitored`,
        });
    }

    getAlertByMerchantCode(ec) {
        return this.fetch({
            url: `${this.baseUrl}/clients/${ec}/alerts`,
        });
    }

    getTransactionsByAlertId(alertId) {
        return this.fetch({
            url: `${this.baseUrl}/alerts/${alertId}/transactions`,
        });
    }

    updateAlert(alert) {
        return this.fetch({
            method: methods.PUT,
            url: `${this.baseUrl}/alerts/${alert.id}`,
            data: alert,
        });
    }
}

export default new AlertService();
